<template>
    <metainfo>
        <template #title="{ content }">
            {{ content ? `${content}` : `新安東京海上產險` }}
        </template>
    </metainfo>
    <div id="app">
        <!-- top按鈕 -->
        <div class="fixed z-50 right-1 bottom-6 opacity-50 xl:right-5">
            <div
                v-scroll-to="'body'"
                class="w-12 h-12 bg-gray-800 rounded-lg flex justify-center items-center cursor-pointer"
            >
                <div class="w-4 h-4">
                    <IconChevronUp class="text-white" />
                </div>
            </div>
        </div>
        <!-- top按鈕 -->

        <router-view
            v-if="$store.state.header"
            name="header"
        />
        <NavigationDrawer
            v-if="$store.state.policy.activityCode !== 'ESUN'"
            :is-open="$store.state.navigationDrawer.isActive"
        />
        <RouterView />
        <CustomFooter class="mt-[80px] bottom-0 z-40" />

        <LoadingOverlay v-if="$store.state.loading" />
        <!-- 長時間沒操作登出提醒 -->
        <Idle v-if="$store.state.idle.isPrompted" />
        <!-- / 長時間沒操作登出提醒 -->
        <!-- 超時登出提醒 -->
        <CustomDialog
            v-if="$store.state.showTimeoutAlert"
            title="超時登出提醒"
            :show-close-button="true"
            :show-header-divider="true"
            @close="$store.commit('clearTimeout')"
        >
            <div class="text-center py-4">
                請重新登入
            </div>
        </CustomDialog>
        <!-- / 超時登出提醒 -->
        <!-- 基本 popup 一次性提示視窗(只顯示於當頁、非跳轉頁面、非獨立頁面，只有關閉功能) -->
        <AlertDialog />
        <!-- / 基本 popup-->

        <div
            v-if="debugPanel"
            class="fixed bottom-0 w-full z-50"
        >
            <div class="flex justify-end">
                <div
                    v-if="$store.state.debug.panel"
                    class="w-8 text-white bg-gray-800 p-2"
                    @click="$store.commit('debug/closePanel')"
                >
                    <IconArrowDown />
                </div>
                <div
                    v-else
                    class="w-8 text-white bg-gray-800 p-2"
                    @click="$store.commit('debug/showPanel')"
                >
                    <IconArrowUp />
                </div>
            </div>
            <div :class="{'hidden': !$store.state.debug.panel}">
                <div class="flex text-[14px]">
                    <div class="p-2 bg-yellow">
                        SessionID: <strong>{{ $store.state.debug.sessionId }}</strong>
                    </div>
                    <div class="bg-blue-700 flex-1">
                        <div
                            v-if="$store.getters['auth/loggedIn']"
                            class="flex"
                        >
                            <div class="flex p-2">
                                <div> JWT <strong>{{ $store.state.auth.jwtExpireSec }}</strong> sec</div>
                                <div class="ml-4">
                                    REFRESH <strong>{{ $store.state.auth.refreshTokenExpireSec }}</strong> sec
                                </div>
                            </div>

                            <div class="flex-1 flex ml-4 bg-pink-800 p-2">
                                <div> IDLE <strong>{{ $store.state.idle.idleTimeout }}</strong> </div>
                                <div class="ml-4">
                                    TIMEOUT <strong>{{ $store.state.idle.timeout }}</strong>
                                </div>
                            </div>
                        </div>
                        <div
                            v-else
                            class="p-2"
                        >
                            未登入
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IconChevronUp from '@/components/icons/ChevronUp';
import CustomFooter from '@/components/Footer';
import LoadingOverlay from '@/components/LoadingOverlay';
import NavigationDrawer from '@/components/NavigationDrawer';
import CustomDialog from '@/components/Dialog';
import AlertDialog from '@/components/AlertDialog';
import IconArrowDown from '@/components/icons/ArrowDown';
import IconArrowUp from '@/components/icons/ArrowUp';
import Idle from '@/components/Idle';

export default {
    components: {IconChevronUp, CustomFooter, Idle, IconArrowUp, IconArrowDown, AlertDialog, CustomDialog, NavigationDrawer, LoadingOverlay},
    metaInfo() {
        const type = this.$route.params.type;
        return {
            title: type === 'car' ? '汽車強制險線上投保真輕鬆，強制險費用試算｜新安東京海上產險'
                : '機車保險強制險線上投保真輕鬆，強制險費用試算｜新安東京海上產險',
            description: type === 'car' ? '網路投保汽車強制險、第三人責任險、車體險、超額責任險及多項保障，方案組合自由搭配，保費金額立即試算，網路投保汽車強制險現省330元，任意險另享82折優惠。'
                : '網路投保機車保險強制險、第三人責任險、駕駛人傷害險、超額責任險及多項保障，方案組合自由搭配，保費金額立即試算，網路投保機車保險強制險一年期現折145元、兩年期現折215元，任意險另享82折優惠。',
            meta: [
                {
                    property: 'og:image',
                    content: 'https://www.tmnewa.com.tw/img/logo.677af7dd.png'
                },
                {
                    property: 'og:title',
                    content: type === 'car' ? '汽車強制險線上投保真輕鬆，強制險費用試算｜新安東京海上產險'
                        : '機車保險強制險線上投保真輕鬆，強制險費用試算｜新安東京海上產險',
                },
                {
                    property: 'og:description',
                    content: type === 'car' ? '網路投保汽車強制險、第三人責任險、車體險、超額責任險及多項保障，方案組合自由搭配，保費金額立即試算，網路投保汽車強制險現省330元，任意險另享82折優惠。'
                        : '網路投保機車保險強制險、第三人責任險、駕駛人傷害險、超額責任險及多項保障，方案組合自由搭配，保費金額立即試算，網路投保機車保險強制險一年期現折145元、兩年期現折215元，任意險另享82折優惠。',
                },
            ]
        };
    },
    data() {
        return {
            debugPanel: process.env.VUE_APP_DEBUG === 'true'
        };
    },
    created(){
        this.$store.commit('policy/setActivityCodeLock', this.$route.query.ActivityCode || null);
        this.$store.commit('setInsCategory', this.$route.params.type == 'car' ? 'Car' : 'Motorcycle');
        this.$store.commit('lookup/active', { estimateId: this.$route.query.EstimateId });
        this.$store.commit('estimate/setValue', {key: 'TelemarketingId', value: this.$route.query.TelemarketingId || null});
        
        if(this.$route.query.iChannels){
            localStorage.setItem('iChannels', this.$route.query.iChannels);
            localStorage.setItem('iChannelsExpire', this.$moment().add(7, 'days').format('YYYYMMDD'));
            this.$store.commit('policy/setCorp', this.$route.query.iChannels);
        }
        else{
            if(window.localStorage.iChannels && window.localStorage.iChannelsExpire){
                if(this.$moment().isAfter(this.$moment(window.localStorage.iChannelsExpire))){
                    localStorage.removeItem('iChannels');
                    localStorage.removeItem('iChannelsExpire');
                }
                else{
                    this.$store.commit('policy/setCorp', window.localStorage.iChannels);
                }
            }
            else{
                this.$store.commit('policy/setCorp', null);
            }
        }
    },
    async mounted() {
        this.$idle.start();
        // SSO登入
        if(!this.$store.getters['auth/loggedIn']) {
            var jwtInfo = window.localStorage.jwtInfo;
            if(jwtInfo !== null && jwtInfo) {
                this.$store.commit('auth/login', JSON.parse(jwtInfo));
                await this.$auth.getUser().then(() => {
                    this.$store.commit('auth/setAccount', this.$store.state.member.id);
                    this.$store.commit('auth/setBirthday', this.$store.state.member.birthday);
                }).catch(err =>{
                    this.$store.commit('auth/logout');                    
                });
            }
        }
        if (this.$store.getters['auth/loggedIn']) {
            this.$auth.tokenCountdown();
        }
        
        if (process.env.VUE_APP_DEBUG === 'true') this.$store.commit('debug/setSessionId'); // 顯示下方 debug panel
        if (process.env.VUE_APP_DISPLAY_VERSION === 'true') console.log('VERSION: 2023-07-15 09:50'); // 顯示版本號於 console
        // 網頁跑比較慢或是第一次進網頁有可能會抓不到fpc 抓不到會每三秒抓一次 直到抓到值為止
        var fpcValue;
        const interval = setInterval(() => {
            fpcValue = window.localStorage.fpc;
            if (fpcValue !== null && fpcValue) {
                this.$store.commit('estimate/setValue', {key: 'uid', value: fpcValue});
                clearInterval(interval);
            }
        }, 3000);
        
        var clarityId;
        const intervalClarity = setInterval(() => {
            clarityId = this.$cookies.get('_clck');
            if (clarityId !== null && clarityId) {
                this.$store.commit('estimate/setValue', {key: 'ClarityId', value: this.$cookies.get('_clck')?.split('|')[0]});
                clearInterval(intervalClarity);
            }
        }, 3000);

        // 傳送gclid事件
        if(this.$route.query.gclid){
            const intervalGclid = setInterval(() => {
                if(this.$store.state.estimate.uid && this.$store.state.estimate.ClarityId) {
                    this.$log.clarityLog('gclid', '');
                    clearInterval(intervalGclid);
                }
            }, 3000);
        }
        
        // 傳送utm事件
        if(this.$route.query.utm_source || this.$route.query.utm_medium) {
            const intervalUtm = setInterval(() => {
                if(this.$store.state.estimate.uid && this.$store.state.estimate.ClarityId) {
                    this.$log.clarityLog('UTM', 'utm_source=' + this.$route.query.utm_source + '&utm_medium=' + this.$route.query.utm_medium);
                    clearInterval(intervalUtm);
                }
            }, 3000);
        }
        
        if(this.$store.state.insCategory === 'Motorcycle' && this.$store.state.policy.activityCode === 'ESUN' && EsunWallet.isESShell && !this.$store.state.esunwallet.huid) {
            EsunWallet.GetHUID();
        }
    },
    methods: {}
};
</script>

<style lang="scss">
/* input規範: focus有藍色下框線 */
.allInputBox:focus-within {
    border-bottom: 2px solid #005BAC;
}

.errorInputBox:focus-within {
    border: 1px solid #EE5B6E;
}

/* 所有頁面共用的容器 */
.carContainer {
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 10px;
    padding-right: 10px;

    @include md { // 768
        margin-top: 80px;
        max-width: 728px;
        padding-left: 20px;
        padding-right: 20px;
    }
    @include lg { // 1024
        max-width: 984px;
    }
    @include xl {
        max-width: 1280px;
        padding-left: 0;
        padding-right: 0;
    }
}
</style>